module.exports = __webpack_public_path__ + "static/media/chimney.77e97edc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/street/chimney.png
// module id = 447
// module chunks = 0